import { Backdrop } from '@carboncopyco/editor-ui';
import { useState } from 'react';
import { useEditor } from '../../context/EditorSdkProvider';
import { useEditorEvent } from '../../hooks/useEditorEvent';

export const BackdropOverlay = () => {
  const [showBackdrop, setShowBackdrop] = useState(false);
  const editorSdk = useEditor();

  useEditorEvent(editorSdk, 'showBackdropOverlay', setShowBackdrop);

  return <Backdrop isOpen={showBackdrop} />;
};
